import { tw } from "@sveabank/cc-common";
import type React from "react";

type Props = {
	children?: React.ReactNode;
	borderColor?: string;
	background: string;
	size: "small" | "large";
};

const NavCircle = ({
	children,
	background,
	size,
	borderColor = "border-interactive-primary",
}: Props) => (
	<div
		className={tw(
			"border-background-primary bg-background-primary relative bottom-[6px] z-30 rounded-full border-[7px]",
			size === "large" ? "mt-[8px]" : "mt-[12px]",
		)}
	>
		<div
			className={tw(
				"relative z-40 flex items-center justify-center rounded-full border-2 border-solid",
				background,
				borderColor,
				size === "large" ? "size-6" : "size-4",
			)}
		>
			{children}
		</div>
	</div>
);
export default NavCircle;
